import { get, post } from '@/api/index';
export const xmCourseInfo = params => get(`/api/course/v1/nologin/xm_course_info`, params); // 小米认证课程详情


